import React from "react";
import { NavLink } from "react-router-dom";
import MainLayout from "../../layouts/MainLayout";

export default function NotFoundPage() {
  return (
    <MainLayout>
      <section className="relative bg-cover bg-not-found-page h-screen">
        <div className="container mx-auto">
          <div className="px-4 text-center md:text-left pt-44 md:pt-60 flex flex-col gap-6 text-white">
            <h1 className="font-bold text-4xl lg:text-6xl">page not found</h1>
            <p>
              It looks like this page has moved somewhere else. come back to the
              homepage
            </p>
            <NavLink
              to="/"
              className="mx-auto md:mx-0 grid place-items-center font-medium w-48 h-12 bg-white rounded-full text-dark-denim"
            >
              back to home
            </NavLink>
          </div>
        </div>
        <img src={require('../../assets/img/404/rocket.png')} alt="" className="absolute -bottom-20 md:top-1/4 lg:top-0 md:right-0 w-4/5 -rotate-180 md:rotate-0 md:w-2/5 pt-32 pr-0" />
      </section>
    </MainLayout>
  );
}
